module.exports = __webpack_public_path__ + "static/media/2.fcf07f12.jpg";